export const NPS_TEMPLATE_ID = 'nps';
export const PURCHASE_TEMPLATE_ID = 'purchase';
export const INVOICE_TEMPLATE_ID = 'invoice';
export const INFO_TEMPLATE_ID = 'info_v2';
export const ACCEPT_TEMPLATE_ID = 'accept';
export const ACCEPT_LINK_TEMPLATE_ID = 'accept_link';
export const HINT_TEMPLATE_ID = 'hint';
export const TOUR_UPDATE_V4_TEMPLATE_ID = 'tour_update_v4';

export const PURCHASE_ACTION_ID = 'purchase';
export const INVOICE_ACTION_ID = 'invoice';
export const INFO_ACTION_ID = 'info';
export const ACCEPT_ACTION_ID = 'accept';
export const ACCEPT_LINK_ACTION_ID = 'accept_link';
export const PLAN_TO_WATCH_ACTION_ID = 'plan_to_watch';
export const HINT_CLOSE_ACTION_ID = 'close_system';
export const REJECT_ACTION_ID = 'reject';
export const RATE_ACTION_ID = 'RATE';
export const NPS_REJECT_ACTION_ID = 'REJECT';
export const DISABLED_PIN_CODE_ACTION_ID = 'disable_pincode';
export const GO_TO_AUTH_ACTION_ID = 'go_to_auth';

export const BATCH_NOTIFICATION_COUNT = 1;
